import request from '@/common/js/request'

export const verificationsPost = (option = {}) => request({
    url: '/apis/verifications',
    method: 'POST',
    ...option
})
